// filepath: c:\Users\Kenny\Documents\GitHub\scholarty\frontend\src\components\LogoScroller.js
import React from "react";

const LogoScroller = ({ logos }) => {
  return (
    <div className="w-full inline-flex flex-nowrap overflow-hidden [mask-image:_linear-gradient(to_right,transparent_0,_black_128px,_black_calc(100%-128px),transparent_100%)]">
      {/* First list of logos */}
      <ul className="flex items-center justify-center md:justify-start [&_li]:mx-8 [&_img]:max-w-none animate-infinite-scroll">
        {logos.map((logo, index) => (
          <li key={`logo-1-${index}`}>
            <img
              src={logo.src}
              alt={logo.alt}
              className="max-h-[80px] w-auto object-contain"
            />
          </li>
        ))}
      </ul>
      {/* Duplicate list for seamless scrolling */}
      <ul
        className="flex items-center justify-center md:justify-start [&_li]:mx-8 [&_img]:max-w-none animate-infinite-scroll"
        aria-hidden="true"
      >
        {logos.map((logo, index) => (
          <li key={`logo-2-${index}`}>
            <img
              src={logo.src}
              alt={logo.alt}
              className="max-h-[80px] w-auto object-contain"
            />
          </li>
        ))}
      </ul>
    </div>
  );
};

export default LogoScroller;
